'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('db-admin-edit', {
      url: '/db-admin/:collection/:id',
      template: '<db-admin-edit></db-admin-edit>',
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/superadmin/db/edit/db-admin-edit.routes.js